import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {Contract, ContractForm} from '../../contract/models/contract';


export const contractDuplicateActionTypes = {
  DUPLICATE: type('[contract] Duplicate'),
  DUPLICATE_SUCCESS: type('[contract] Duplicate Success'),
  DUPLICATE_FAIL: type('[contract] Duplicate Fail'),
};

export class DuplicationContractAction implements Action {
  readonly type = contractDuplicateActionTypes.DUPLICATE;
  constructor(public payload?: {contractForm: ContractForm , companyUuid: string }) {}
}

export class DuplicationContractSuccessAction implements Action {
  readonly type = contractDuplicateActionTypes.DUPLICATE_SUCCESS;
  constructor(public payload?: Contract) {}
}

export class DuplicationContractFailAction implements Action {
  readonly type = contractDuplicateActionTypes.DUPLICATE_FAIL;
  constructor(public payload?: string) {}
}


